import { PERMISSIONS } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { hasPermissions } from 'app/shared/auth/private-route';
import { getSession } from 'app/shared/reducers/authentication';
import React, { useEffect, useRef } from 'react';

const Messages = () => {
  const dispatch = useAppDispatch();

  const permissions = useAppSelector(state => state.authentication.account.permissions);
  const canSendMessage = hasPermissions(permissions, [PERMISSIONS.ALL, PERMISSIONS.MESSAGES_EDIT]);

  const authToken = JSON.parse(localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken'));

  const account = useAppSelector(state => state.authentication.account);
  const isAccountLoading = useAppSelector(state => state.authentication.loading);

  const iframeUrl = REACT_APP_CRM_URL + '?platform=1&entity=all';

  const iframe = useRef<HTMLIFrameElement>(null);

  const sendMessage = (parameters: any) => {
    iframe?.current?.contentWindow?.postMessage(
     parameters,
      '*',
    );
  };

  // const toast = useToast()

  useEffect(() => {
    window.addEventListener('message', (event: any) => {
      if (event.data.messagesLoaded) {
        /**colors will be rgba numbers. They are intercepted with rgba function in styles*/
        const parameters = { token: authToken, user: account, payload: { entity: 'all' }, isReadOnly: canSendMessage, styles: { primaryColor: '22, 136, 132', primaryHover: '21, 113, 136' } };
        sendMessage(parameters);
      }
    });
    dispatch(getSession());
  }, []);

  return (
    <>
      {isAccountLoading ? (
        <p>Loading...</p>
      ) : (
        <div className="device-message-tab">
          <iframe id="messagesPortalIframe" ref={iframe} src={iframeUrl} width="100%" height="100%" title="Messages"></iframe>
        </div>
      )}
    </>
  );
};

export default Messages;
